module.exports = {
  annotate: require(64).annotate,
  Module: require(67),
  Injector: require(66)
};
